import LANGUAGES from './languageEnums';

export default function getLanguageNamesByCode(code) {
    const language = LANGUAGES.supportedList.find(lang => lang.value === code);
    return language ? language.display_name : null;
}
